module.exports = require("@pb/kit-util-add-style");